module.exports = __webpack_public_path__ + "static/media/p5.b32ea567.png";